import { AnyT, jsonMember, jsonObject } from 'typedjson';
import { PublicCartAttributeName } from '../../types/public-cart-attribute-name';
import { Nillable } from '@web/utils';

@jsonObject
export class PublicCartAttributeRequest {
  @jsonMember(String)
  public readonly propertyPath!: PublicCartAttributeName;

  @jsonMember(AnyT)
  public readonly value?: Nillable<string | boolean>;

  public constructor(
    private readonly data: {
      propertyPath: PublicCartAttributeName;
      value?: Nillable<string | boolean>;
    },
  ) {
    this.propertyPath = this.data.propertyPath;
    this.value = this.data.value;
  }
}
